import { surveyAnalyticsService } from '../../services/SurveyAnalytics.service'
import OktaUserDetails from "../../Helpers/OktaUserDetails"

const state = {
    allFilterCategories: [], //filters for all tabs.
    filterCategories: [], // filters for current selected tab.

    categoriesPopulated: false,
    yourDatafilterCategories: [],
    benchmarkfilterCategories: [],
    segmentfilterCategories: [],
    cohortMeasurefilterCategories: [],
    cohortSegmentfilterCategories: [],

    //cohortMeasures: [],
    // respective models for tabs.
    modelYourDataFilters: {
        keyValues: []
    },

    //tblYourDataFilters: {
    //    keyValues: []
    //},

    tblYourDataFilters: [],
    tblBenchmarkFilters: [],
    tblSegmentFilters: [],
    tblCohortFilters: [],

    modelBenchmarkFilters: {
        keyValues: []
    },

    modelSegmentFilters: {
        keyValues: []
    },

    modelCohortFilters: { //Measure selections for Cohort.
        keyValues: []
    },

    modelCohortListFilters: [],

    yourDataFiltersApplied: false,
    benchmarkFiltersApplied: false,
    segmentFiltersApplied: false,
    cohortFiltersApplied: false,

    yourDataFilterRadios: [],
    benchmarkFilterRadios: [],
    segmentFilterRadios: [],
    cohortFilterRadios: [],

    cohortPanel: []
}
// getters
const getters = {
}

function getUserId() {
    return new OktaUserDetails().getUserId();
}

// actions
const actions = {
    settblYourDataFilters({ commit }, Categories) {
        commit('settblYourDataFilters', Categories);
    },
    settblBenchmarkFilters({ commit }, Categories) {
        commit('settblBenchmarkFilters', Categories);
    },
    settblSegmentFilters({ commit }, Categories) {
        commit('settblSegmentFilters', Categories);
    },
    settblCohortFilters({ commit }, Categories) {
        commit('settblCohortFilters', Categories);
    },
    setyourDataFiltersApplied({ commit }) {
        commit('setyourDataFiltersApplied');
    },
    updateModelCohort({ commit }, modelObj) {
        commit('updateModelCohort', modelObj);
    },
    //reset modelCohort list after deleting the cohort.
    /*resetmodelCohort({ commit }, deletingCohortId) {
        commit('resetmodelCohort', { deletingCohortId });
    },*/
    resetYourDataFilters({ commit }) {
        commit('resetYourDataFilters');
    },
    resetBenchmarkFilters({ commit }) {
        commit('resetBenchmarkFilters');
    },
    resetSegmentFilters({ commit }) {
        commit('resetSegmentFilters');
    },
    getAllCategories({ dispatch, commit, state, rootState }) {
        // console.log(localStorage.getItem("UserClientId"));
        //console.log(localStorage.getItem("UserClientName"));
        //let userDetails = this.$store.getters['Authentication/getUserToken'];
        dispatch('UserManagementStore/getUserClientDetails', null, { root: true }).then(() => {
            let clientId = rootState.UserManagementStore.UserClientId;
            let userId = getUserId();
            let productLine = rootState.AppStore.ProductLine.payload.trim();
            const params = 'productType=' + productLine + '&clientID=' + clientId + '&userid=' + userId;
            //const params = 'productType=30&clientID=404&userid=e52b1b95-e0e8-427a-b537-e6a7c538e5f4'
            if (!state.categoriesPopulated) {
                return new Promise((resolve, reject) => {
                    surveyAnalyticsService.getAllCategories(
                        params,
                        categories => {
                            commit('setCategories', { categories });
                            resolve()
                        },
                        err => {
                            reject(err)
                        })
                })
            }
        }).catch(error => {
        });
    },
}

// mutations
const mutations = {
    settblYourDataFilters(state, data) {
        state.tblYourDataFilters = data
    },
    settblBenchmarkFilters(state, data) {
        state.tblBenchmarkFilters = data
    },
    settblSegmentFilters(state, data) {
        state.tblSegmentFilters = data
    },
    settblCohortFilters(state, data) {
        state.tblCohortFilters = data
    },
    setyourDataFiltersApplied(state) {
        state.yourDataFiltersApplied = true;
    },
    setCategories(state, { categories }) {

        state.categoriesPopulated = true;

        state.yourDatafilterCategories = categories.filter((cat) => {
            return cat.displaySection == 'mydata';
        });

        state.benchmarkfilterCategories = categories.filter((cat) => {
            return cat.displaySection == 'benchmark';
        });

        state.segmentfilterCategories = categories.filter((cat) => {
            return cat.displaySection == 'segment';
        });

        state.cohortMeasurefilterCategories = categories.filter((cat) => {
            return cat.displaySection == 'cohort' && cat.categoryName == 'Measures';
        });

        state.cohortSegmentfilterCategories = categories.filter((cat) => {
            return cat.displaySection == 'cohort' && cat.categoryName != 'Measures';
        });
        state.yourDatafilterCategories.map((cat) => {
            let keyval = cat.keyValues.filter((data) => {
                return data.isSelected == true;
            })
            keyval.map((data) => {
                state.yourDataFilterRadios.push(data.itemValue)
            })
        })
        state.benchmarkfilterCategories.map((cat) => {
            let keyval = cat.keyValues.filter((data) => {
                return data.isSelected == true;
            })
            keyval.map((data) => {
                state.benchmarkFilterRadios.push(data.itemValue)
            })
        })
        state.segmentfilterCategories.map((cat) => {
            let keyval = cat.keyValues.filter((data) => {
                return data.isSelected == true;
            })
            keyval.map((data) => {
                state.segmentFilterRadios.push(data.itemValue)
            })
        })
        state.cohortMeasurefilterCategories.map((cat) => {
            let keyval = cat.keyValues.filter((data) => {
                return data.isSelected == true;
            })
            keyval.map((data) => {
                state.cohortFilterRadios.push(data.itemValue)
            })
        })
        state.segmentfilterCategories.map((cat) => {
            let selCategory = {
                categoryName: cat.categoryName,
                keyValues: []
            };
            let keyval = cat.keyValues.filter((data) => {
                return data.isSelected == true;
            })
            if (keyval.length > 0) {
                selCategory.keyValues = keyval;
            }
            state.segmentFilterRadios.map((radio) => {
                let keyval = cat.keyValues.filter((data) => {
                    return radio == data.itemValue && data.isSelected == false;
                })
                if (keyval.length > 0) {
                    selCategory.keyValues = keyval;
                }
            })
            if (selCategory.keyValues.length > 0) {
                state.tblSegmentFilters.push(selCategory);
            }
        })
        state.cohortMeasurefilterCategories.map((cat) => {
            let selCategory = {
                categoryName: cat.categoryName,
                keyValues: []
            };
            let keyval = cat.keyValues.filter((data) => {
                return data.isSelected == true;
            })
            if (keyval.length > 0) {
                selCategory.keyValues = keyval;
            }
            state.cohortFilterRadios.map((radio) => {
                let keyval = cat.keyValues.filter((data) => {
                    return radio == data.itemValue && data.isSelected == false;
                })
                if (keyval.length > 0) {
                    selCategory.keyValues = keyval;
                }
            })
            if (selCategory.keyValues.length > 0) {
                state.tblCohortFilters.push(selCategory);
            }
        })
    },
    resetYourDataFilters() {
        state.modelYourDataFilters = [];
    },
    resetBenchmarkFilters() {
        state.modelBenchmarkFilters = [];
    },
    resetSegmentFilters() {
        state.modelSegmentFilters = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}